export const brands=[
  {id:'northstar',name:'Northstar Wealth',monogram:'NW',primary:'#19382f',accent:'#c99b5a',voice:'Assured,clear,and quietly optimistic.'},
  {id:'dale',name:'Dale & Co.',monogram:'D&C',primary:'#24364b',accent:'#cf694d',voice:'Candid,insightful,and distinctly human.'},
  {id:'foundry',name:'Foundry Advisory',monogram:'FA',primary:'#422b3d',accent:'#d2a646',voice:'Decisive,intelligent,and forward-looking.'},
  {id:'prosperity',name:'Prosperity Leaders',monogram:'PL',primary:'#172c46',accent:'#c9a24c',voice:'Warm,relationship-first,and community-oriented.'},
  {id:'gfi',name:'Global Financial Impact',monogram:'GFI',primary:'#1765a5',accent:'#f4f7fb',voice:'Aspirational,mission-driven,and focused on lasting impact.'}
];

export const postTemplates=[
  {
    headline:'Clarity is the first return on investment.',
    supporting:'A financial professional helps turn uncertainty into a plan you can act on.',
    caption:{
      instagram:'Clarity is the first return on investment. Start there,then build the plan. #FinancialPlanning #BuildWithPurpose',
      linkedin:'The strongest financial decisions rarely begin with a product. They begin with clarity: a clear view of where you are,where you want to go,and what matters along the way. A thoughtful financial plan turns that clarity into decisions you can act on.',
      facebook:'A strong financial plan starts with clarity. When you understand where you are and where you want to go,the next decision becomes much easier to make. What would greater clarity help you act on today?'
    },
    image:'https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1400&q=85'
  },
  {
    headline:'Your future deserves more than a guess.',
    supporting:'Thoughtful planning creates room for confident decisions today.',
    caption:{
      instagram:'Your future deserves more than a guess. Make a plan you can believe in. #WealthStrategy #FinancialConfidence',
      linkedin:'A good financial plan does more than prepare you for tomorrow. It provides a framework for making better decisions today,while keeping long-term priorities visible as circumstances change.',
      facebook:'Your future deserves more than a guess. A thoughtful plan gives you something solid to come back to when life gets busy or the market gets noisy.'
    },
    image:'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1400&q=85'
  },
  {
    layout:'fullbleed',
    headline:'Make room for what matters.',
    supporting:'',
    caption:{
      instagram:'Make room for what matters. #Focus #Leadership',
      linkedin:'The most important work often needs space before it needs speed. Protect the room to think clearly about what matters most.',
      facebook:'Sometimes the best next step is not doing more — it is making room for what already matters.'
    },
    image:''
  },
  {
    layout:'fullbleed',
    headline:'Clarity is a competitive advantage.',
    supporting:'The teams that move with purpose rarely confuse activity for progress.',
    caption:{
      instagram:'Clarity is a competitive advantage. Move with purpose,not noise. #Strategy #Clarity',
      linkedin:'Clarity changes how teams prioritize,communicate,and execute. When purpose is visible,progress becomes easier to recognize and sustain.',
      facebook:'When the goal is clear,everyone can pull in the same direction. Clarity is not a soft skill — it is a practical advantage.'
    },
    image:''
  },
  {
    layout:'framed',
    headline:'Space to think creates better decisions.',
    supporting:'Protect the quiet moments that let strategy take shape.',
    caption:{
      instagram:'Space to think creates better decisions. Guard the quiet moments. #Leadership #Strategy',
      linkedin:'Better decisions rarely come from constant reaction. Creating space to think gives leaders room to weigh tradeoffs,see patterns,and act with intention.',
      facebook:'Not every hour needs to be full. Protecting a little space to think can make the rest of your decisions sharper.'
    },
    image:'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1400&q=85'
  }
];

export const initialPosts=[
  {
    id:101,
    brandId:'northstar',
    prompt:'Why long-term planning matters',
    headline:'The long view changes everything.',
    supporting:'A thoughtful plan helps today’s decisions serve tomorrow’s ambitions.',
    caption:{
      instagram:'The long view changes everything. Small,intentional decisions add up. #FinancialPlanning #LongTermThinking',
      linkedin:'Long-term planning changes the context in which today’s financial decisions are made. A thoughtful plan helps ensure that current choices remain connected to tomorrow’s ambitions.',
      facebook:'It is easier to make today’s decisions when you know what they are working toward. The long view gives your plan direction and your next step more confidence.'
    },
    image:'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-06-18',
    rejectionReason:'',
    createdAt:'Today,9:42 AM'
  },
  {
    id:102,
    brandId:'northstar',
    prompt:'Prepare for market uncertainty',
    headline:'Confidence is built before uncertainty arrives.',
    supporting:'Preparation gives you perspective when markets get noisy.',
    caption:{
      instagram:'Confidence is built before uncertainty arrives. Prepare with perspective. #Investing #FinancialConfidence',
      linkedin:'Confidence during periods of market uncertainty is generally the result of preparation that began well in advance. A resilient plan provides perspective and helps keep short-term conditions in context.',
      facebook:'Markets will have noisy moments. The good news is that you do not have to wait for one to start preparing. A clear plan can help you keep perspective when things feel uncertain.'
    },
    image:'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-12',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 18'
  },
  {
    id:201,
    brandId:'dale',
    prompt:'Founders need time to think',
    headline:'Your calendar tells the truth.',
    supporting:'Protect the time that lets you lead instead of simply react.',
    caption:{
      instagram:'Your calendar tells the truth. Protect the time that lets you lead. #FounderLife #Leadership',
      linkedin:'A founder’s calendar often reveals the priorities that receive attention in practice. Protecting time for strategic thinking is an important part of leading a business rather than simply reacting to its demands.',
      facebook:'Your calendar says a lot about what has your attention. If every hour is spent reacting,where will you find the time to think about what comes next?'
    },
    image:'https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 17'
  },
  {
    id:301,
    brandId:'foundry',
    prompt:'Building a resilient company',
    headline:'Resilience is designed,not discovered.',
    supporting:'Strong foundations create options when conditions change.',
    caption:{
      instagram:'Resilience is designed,not discovered. Build the foundation before you need it. #BusinessStrategy #Resilience',
      linkedin:'Resilience is not simply a response to changing conditions. It is built into the strategy through strong foundations,thoughtful planning,and the creation of options before they become necessary.',
      facebook:'Resilient companies are not lucky. They build strong foundations,think ahead,and create options before circumstances force them to. That work makes a difference when conditions change.'
    },
    image:'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1200&q=80',
    status:'rejected',
    scheduledDate:null,
    rejectionReason:'Needs a more optimistic tone.',
    createdAt:'May 15'
  },
  {
    id:401,
    brandId:'prosperity',
    prompt:'Building a household emergency fund',
    headline:'A little breathing room can change everything.',
    supporting:'Saving for the unexpected is one practical way to care for the people who count on you.',
    caption:{
      instagram:'A little breathing room can change everything. An emergency fund is not about fear,it is about giving your family more choices when life surprises you. #MoneyManagement #EmergencyFund',
      linkedin:'An emergency fund is a practical foundation for household confidence. Even small,consistent contributions can create breathing room and help a family respond to an unexpected expense without losing sight of longer-term goals.',
      facebook:'Life does not always follow the plan. Setting aside a little at a time can give your family more breathing room when an unexpected expense comes along. No pressure,no perfection — just one helpful step at a time.'
    },
    image:'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-10',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 10'
  },
  {
    id:402,
    brandId:'prosperity',
    prompt:'Invite families to a community financial workshop',
    headline:'Good conversations make money feel less intimidating.',
    supporting:'A welcoming room can be the first step toward a clearer financial future.',
    caption:{
      instagram:'Money conversations feel different when they happen in a welcoming room with people who care. Join us for a practical conversation about cash flow,saving,and next steps. #FinancialEducation #CommunityFirst',
      linkedin:'Financial education works best when people feel comfortable asking honest questions. Community workshops create space for families to talk through cash flow,saving,and protection in a practical,no-pressure environment.',
      facebook:'You do not have to figure everything out alone. We are creating a welcoming space for families to talk about money management,ask questions,and leave with one or two practical next steps.'
    },
    image:'https://images.unsplash.com/photo-1515169067868-5387ec356754?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-06-24',
    rejectionReason:'',
    createdAt:'June 9'
  },
  {
    id:403,
    brandId:'prosperity',
    prompt:'Explain why income protection matters',
    headline:'Protecting income protects possibilities.',
    supporting:'Insurance conversations are really about keeping life moving when the unexpected happens.',
    caption:{
      instagram:'Protecting income is one way to protect the plans your family is building. Start with a conversation,not a sales pitch. #IncomeProtection #FamilyPlanning',
      linkedin:'Income protection is often less about products and more about preserving the choices a family has worked hard to create. The right conversation begins with understanding priorities,dependents,and what needs to keep moving.',
      facebook:'Your income supports more than bills. It supports routines,dreams,and the people you love. A thoughtful conversation about protection can help keep those possibilities in place.'
    },
    image:'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 7'
  },
  {
    id:404,
    brandId:'prosperity',
    prompt:'Talk about debt and credit basics',
    headline:'Progress starts with an honest look.',
    supporting:'Understanding your numbers is a powerful first step toward more confident choices.',
    caption:{
      instagram:'Progress starts with an honest look at what is coming in,what is going out,and what you want to change. Small steps count. #DebtFreeJourney #FinancialConfidence',
      linkedin:'Debt and credit conversations do not need to begin with shame. A clear look at balances,interest,and monthly cash flow can help turn a difficult topic into a set of practical decisions.',
      facebook:'There is no judgment in getting clear about your numbers. Knowing what you owe,what it costs,and what you can change is a strong first step — and you do not have to take it alone.'
    },
    image:'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1200&q=80',
    status:'rejected',
    scheduledDate:null,
    rejectionReason:'Make the message feel more inviting and less instructional.',
    createdAt:'June 4'
  },
  {
    id:405,
    brandId:'prosperity',
    prompt:'Invite a church,workplace,or nonprofit to host a workshop',
    headline:'Bring a financial education workshop to your community.',
    supporting:'Create a welcoming place for families to ask questions,build clarity,and take their next step.',
    caption:{
      instagram:'Your community deserves a comfortable place to talk about money. Bring a free Financial Education | Wealth Solutions workshop to your church,workplace,or nonprofit. No pressure — just practical conversations for real families. #FinancialEducation #CommunityWorkshop #StartYourLegacyToday',
      linkedin:'Churches,workplaces,and nonprofits are trusted places where meaningful conversations already happen. Partner with us to bring a free financial education workshop to your community and help families explore cash flow,saving,protection,and wealth solutions in a no-pressure environment.',
      facebook:'Could your church,workplace,or nonprofit use a welcoming conversation about money? We partner with community organizations to bring practical financial workshops to families. No pressure,no sales pitch — just education,questions,and helpful next steps.'
    },
    image:'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-07-08',
    rejectionReason:'',
    createdAt:'June 2'
  },
  {
    id:406,
    brandId:'prosperity',
    prompt:'Recruit financial professionals and agency owners',
    headline:'Build a career around helping families move forward.',
    supporting:'Developing Financial Pros & Agency Owners starts with a relationship-first commitment to service.',
    caption:{
      instagram:'Looking for work that means more than selling a product? We are developing Financial Pros & Agency Owners who want to help families make real financial decisions with clarity and care. #FinancialProfessionals #AgencyOwners #StartYourLegacyToday',
      linkedin:'The best financial careers are built on trust. We are developing Financial Pros & Agency Owners who want to educate families,serve their communities,and build a lasting practice around real relationships — not pressure.',
      facebook:'If you want a career helping families make real financial decisions,there is room for you here. We are developing Financial Pros & Agency Owners who lead with education,relationships,and a genuine desire to serve.'
    },
    image:'https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 29'
  },
  {
    id:407,
    brandId:'prosperity',
    prompt:'Teach a clarity-first approach to household cash flow',
    headline:'A clear cash-flow picture creates room to breathe.',
    supporting:'Budgeting is not about restriction;it is about knowing what your money needs to do next.',
    caption:{
      instagram:'A budget can be a form of care. When you know what is coming in,what is going out,and what matters most,you can make decisions with less stress and more clarity. #CashFlow #MoneyManagement #FinancialEducation',
      linkedin:'Cash-flow planning does not have to feel restrictive. It gives a household a clearer picture of priorities and creates a practical starting point for saving,protecting income,and building toward long-term goals.',
      facebook:'You do not need a perfect spreadsheet to begin. Start by looking at what comes in,what goes out,and what your family wants money to make possible. Clarity is a helpful first step.'
    },
    image:'https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-21',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 26'
  },
  {
    id:501,
    brandId:'gfi',
    prompt:'The 5 Fs philosophy',
    headline:'A full life is built on more than one kind of wealth.',
    supporting:'Faith,Family,Finance,Fun,and Fitness give ambition a foundation worth protecting.',
    caption:{
      instagram:'The 5 F’s remind us that success is bigger than a number: Faith,Family,Finance,Fun,and Fitness. Build a life that grows in every direction. #The5Fs #GlobalFinancialImpact',
      linkedin:'Financial independence is most meaningful when it supports a full life. Our 5 F’s — Faith,Family,Finance,Fun,and Fitness — keep the conversation grounded in the people,health,and purpose behind every goal.',
      facebook:'Wealth is not only what you accumulate. It is also the time,health,relationships,and purpose you are able to protect. That is why we think about the 5 F’s: Faith,Family,Finance,Fun,and Fitness.'
    },
    image:'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-08',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 8'
  },
  {
    id:502,
    brandId:'gfi',
    prompt:'Building generational wealth',
    headline:'Legacy is what continues after the conversation.',
    supporting:'Generational wealth begins with knowledge,ownership,and choices made with the future in mind.',
    caption:{
      instagram:'Legacy starts with the choices we make today — and the knowledge we pass forward. #GenerationalWealth #FinancialIndependence',
      linkedin:'Generational wealth is built through more than accumulation. It grows through financial literacy,ownership,and the habits families are willing to teach and model for the next generation.',
      facebook:'A lasting legacy is not only something you leave behind. It is the confidence,knowledge,and opportunities you help the next generation carry forward.'
    },
    image:'https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-06-27',
    rejectionReason:'',
    createdAt:'June 6'
  },
  {
    id:503,
    brandId:'gfi',
    prompt:'Invite entrepreneurs to become business partners',
    headline:'Your ambition can create a wider impact.',
    supporting:'Build a business that gives more people access to education,opportunity,and a bigger vision for their future.',
    caption:{
      instagram:'What if your entrepreneurial journey could help more families build theirs? We are growing a community of business partners who believe impact and independence can grow together. #Entrepreneurship #FinancialImpact',
      linkedin:'Business ownership can be a vehicle for both personal growth and wider impact. We are building with entrepreneurs who want to develop their skills,serve more families,and create a legacy of opportunity.',
      facebook:'We believe entrepreneurship can be about more than building something for yourself. It can also be about opening doors for families and creating a community where more people can imagine a different future.'
    },
    image:'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 3'
  },
  {
    id:504,
    brandId:'gfi',
    prompt:'Share a financial literacy statistic',
    headline:'Financial literacy turns possibility into a plan.',
    supporting:'The more we understand our choices,the more confidently we can shape what comes next.',
    caption:{
      instagram:'Financial literacy is not about knowing everything. It is about having enough understanding to ask better questions and take your next step with confidence. #FinancialLiteracy #Impact',
      linkedin:'Financial literacy creates agency. When people understand the basics of cash flow,protection,credit,and long-term planning,they are better equipped to make decisions that support independence and generational progress.',
      facebook:'You do not need to be a financial expert to start learning. One better question,one clearer conversation,and one intentional choice can change the direction of a family’s financial story.'
    },
    image:'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1200&q=80',
    status:'rejected',
    scheduledDate:null,
    rejectionReason:'Add a specific statistic or make the educational takeaway more concrete.',
    createdAt:'May 30'
  },
  {
    id:505,
    brandId:'gfi',
    prompt:'Use a financial literacy statistic to inspire action',
    headline:'Too many families are still waiting for financial clarity.',
    supporting:'Education can turn uncertainty into confidence,independence,and a future families can see clearly.',
    caption:{
      instagram:'Nearly 2 in 3 adults around the world are considered financially illiterate. The opportunity is clear: empower families to learn,plan,and dream again. #FinancialLiteracy #FinancialIndependence #GlobalFinancialImpact',
      linkedin:'The World Bank has reported that only about one in three adults globally understand basic financial concepts. That gap is more than a statistic — it is a call to action to expand financial education and empower families to turn dreams into reality.',
      facebook:'When families have access to financial education,they have more tools to make confident choices. The need is real,and so is the opportunity to inspire families to dream again and build a stronger future.'
    },
    image:'https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-07-11',
    rejectionReason:'',
    createdAt:'May 27'
  },
  {
    id:506,
    brandId:'gfi',
    prompt:'Connect Finance in the 5 Fs to a fuller life',
    headline:'Finance is the gateway to impact.',
    supporting:'Financial freedom creates room for faith,family,fun,and the vitality to live with intention.',
    caption:{
      instagram:'Finance is not the finish line. It is the gateway that can give your Faith,Family,Fun,and Fitness more room to grow. Build the life behind the number. #The5Fs #FinancialFreedom',
      linkedin:'Within the 5 F’s,Finance is the gateway to impact. Greater financial clarity can create more room for family,health,purpose,and the experiences that make a full life worth building.',
      facebook:'Financial freedom is not only about having more money. It is about having more choice — more time for family,more energy for fitness,more space for fun,and more capacity to make an impact.'
    },
    image:'https://images.unsplash.com/photo-1504150558240-0b4fd8946624?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-19',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 24'
  },
  {
    id:507,
    brandId:'gfi',
    prompt:'Invite a future business partner into the GFI movement',
    headline:'Build a legacy that moves with you.',
    supporting:'Join a movement of financial professionals helping families pursue independence and possibility.',
    caption:{
      instagram:'Your business can be more than a business. Become a GFI business partner and help build a movement that inspires families to dream again. #BusinessPartner #LegacyBuilding #FinancialImpact',
      linkedin:'We are looking for purpose-driven entrepreneurs who want to build a business and a legacy at the same time. As a GFI business partner,you can join a growing movement focused on financial education,independence,and lasting family impact.',
      facebook:'If you have ever wanted your work to reach beyond your own goals,there is a bigger opportunity to explore. GFI business partners join a movement built around helping families achieve financial independence and turning dreams into reality.'
    },
    image:'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'May 21'
  }
];